import Phaser from 'phaser';
import { GAME_HEIGHT, GAME_WIDTH } from '../config/gameConstants';
import { ChaosFrame, SceneKeys, TextureKeys } from '../config/keys';
import { GameOverData } from '../types/gameState';

export class GameOverScene extends Phaser.Scene {
  private distance = 0;
  private bestDistance = 0;
  private funniestCollision = 'gravity stole an acorn';

  constructor() {
    super(SceneKeys.GameOver);
  }

  init(data: GameOverData): void {
    this.distance = data.distance ?? 0;
    this.bestDistance = data.bestDistance ?? 0;
    this.funniestCollision = data.funniestCollision ?? this.funniestCollision;
  }

  create(): void {
    this.add.tileSprite(0, 0, GAME_WIDTH, GAME_HEIGHT, TextureKeys.Background).setOrigin(0);
    this.add.image(GAME_WIDTH / 2, 148, TextureKeys.ChaosSheet, ChaosFrame.SquirrelAnnoyed).setScale(0.54).setAngle(-3);

    this.add
      .text(GAME_WIDTH / 2, 244, 'chaos complete', {
        fontFamily: '"Trebuchet MS", "Comic Sans MS", sans-serif',
        fontSize: '50px',
        color: '#28221a',
        stroke: '#fff7d8',
        strokeThickness: 8,
      })
      .setOrigin(0.5);

    this.add
      .text(GAME_WIDTH / 2, 326, `${this.distance} yards of nonsense\nbest ${this.bestDistance}\n${this.funniestCollision}`, {
        fontFamily: '"Trebuchet MS", "Comic Sans MS", sans-serif',
        fontSize: '25px',
        color: '#3f3324',
        lineSpacing: 10,
        align: 'center',
        backgroundColor: '#fff7d8',
        padding: { x: 18, y: 12 },
      })
      .setOrigin(0.5);

    this.createButton(GAME_WIDTH / 2, 444, 280, 62, 'LAUNCH AGAIN', '#f8d36d', () => this.scene.start(SceneKeys.Game));
    this.createButton(GAME_WIDTH / 2, GAME_HEIGHT - 42, 150, 48, 'MENU', '#d8ead0', () => this.scene.start(SceneKeys.Menu));

    this.input.keyboard?.once('keydown-SPACE', () => this.scene.start(SceneKeys.Game));
    this.input.keyboard?.once('keydown-ENTER', () => this.scene.start(SceneKeys.Game));
    this.input.keyboard?.once('keydown-R', () => this.scene.start(SceneKeys.Game));
  }

  private createButton(x: number, y: number, width: number, height: number, label: string, fill: string, onClick: () => void): void {
    const graphics = this.add.graphics().setDepth(10);
    graphics.fillStyle(Phaser.Display.Color.HexStringToColor(fill).color, 1);
    graphics.lineStyle(4, 0x28221a, 0.88);
    graphics.fillRoundedRect(x - width / 2, y - height / 2, width, height, 8);
    graphics.strokeRoundedRect(x - width / 2, y - height / 2, width, height, 8);

    const text = this.add
      .text(x, y, label, {
        fontFamily: '"Trebuchet MS", "Comic Sans MS", sans-serif',
        fontSize: label === 'MENU' ? '20px' : '30px',
        color: '#28221a',
      })
      .setOrigin(0.5)
      .setDepth(11);

    const zone = this.add
      .zone(x, y, width, height)
      .setOrigin(0.5)
      .setDepth(12)
      .setInteractive({ useHandCursor: true });

    zone.on(Phaser.Input.Events.POINTER_OVER, () => {
      graphics.clear();
      graphics.fillStyle(0x62e4ef, 1);
      graphics.lineStyle(4, 0x28221a, 0.88);
      graphics.fillRoundedRect(x - width / 2, y - height / 2, width, height, 8);
      graphics.strokeRoundedRect(x - width / 2, y - height / 2, width, height, 8);
    });
    zone.on(Phaser.Input.Events.POINTER_OUT, () => {
      graphics.clear();
      graphics.fillStyle(Phaser.Display.Color.HexStringToColor(fill).color, 1);
      graphics.lineStyle(4, 0x28221a, 0.88);
      graphics.fillRoundedRect(x - width / 2, y - height / 2, width, height, 8);
      graphics.strokeRoundedRect(x - width / 2, y - height / 2, width, height, 8);
    });
    zone.on(Phaser.Input.Events.POINTER_UP, onClick);

    text.disableInteractive();
  }
}
